export default {
  title: 'Detail domu',

  demoCategory: 'Dům',

  BuildingInfo: {
    isLoading: 'Probíhá náčítání informací o budově…',
    category: 'Kategorie',
    admins: 'Administrátor',
  },

  Overview: {
    showUnits: 'Zobrazit jednotky',
    ownersLabel_one: 'vlastník',
    ownersLabel_few: 'vlastníci',
    ownersLabel_many: 'vlastníka',
    ownersLabel_other: 'vlastníků',
    constructionTitle: 'Technické údaje o domě',
    constructionSource: 'Zdroj: RUIAN (ČÚZK)',
    yes: 'Ano',
    no: 'Ne',
    // i18next plurál sufixy pro češtinu: _one (1), _few (2-4), _many (desetinná čísla), _other (5+)
    UnitCounts: {
      flat_one: 'byt',
      flat_few: 'byty',
      flat_many: 'bytu',
      flat_other: 'bytů',
      studio_one: 'ateliér',
      studio_few: 'ateliéry',
      studio_many: 'ateliéru',
      studio_other: 'ateliérů',
      garage_one: 'garáž',
      garage_few: 'garáže',
      garage_many: 'garáže',
      garage_other: 'garáží',
      workshop_one: 'provozovna/dílna',
      workshop_few: 'provozovny/dílny',
      workshop_many: 'provozovny/dílny',
      workshop_other: 'provozoven/dílen',
      other_one: 'jiný nebytový prostor',
      other_few: 'jiné nebytové prostory',
      other_many: 'jiného nebytového prostoru',
      other_other: 'jiných nebytových prostorů',
      unit_under_construction_one: 'rozestavěná jednotka',
      unit_under_construction_few: 'rozestavěné jednotky',
      unit_under_construction_many: 'rozestavěné jednotky',
      unit_under_construction_other: 'rozestavěných jednotek',
      group_of_flats_one: 'skupina bytů',
      group_of_flats_few: 'skupiny bytů',
      group_of_flats_many: 'skupiny bytů',
      group_of_flats_other: 'skupin bytů',
      group_of_non_residential_one: 'skupina nebytových prostorů',
      group_of_non_residential_few: 'skupiny nebytových prostorů',
      group_of_non_residential_many: 'skupiny nebytových prostorů',
      group_of_non_residential_other: 'skupin nebytových prostorů',
      group_of_flats_and_non_residential_one: 'skupina bytů a nebytových prostorů',
      group_of_flats_and_non_residential_few: 'skupiny bytů a nebytových prostorů',
      group_of_flats_and_non_residential_many: 'skupiny bytů a nebytových prostorů',
      group_of_flats_and_non_residential_other: 'skupin bytů a nebytových prostorů',
    },
    Fields: {
      useOfConstruction: 'Způsob využití',
      countOfFloors: 'Počet podlaží',
      finishedAt: 'Rok dokončení',
      elevator: 'Výtah',
      heating: 'Vytápění',
      waterConnection: 'Vodovod',
      gasConnection: 'Plyn',
      sewerConnection: 'Kanalizace',
      floorArea: 'Podlahová plocha',
      buildUpArea: 'Zastavěná plocha',
      enclosedArea: 'Obestavěný prostor',
    },
  },

  Subscription: {
    expirationDate: 'Datum expirace předplatného',
    unusedVotes: 'Nevyužitá jednorázová hlasování',
    order: 'Objednat služby',
    extend: 'Prodloužit',
    showOrder: 'Zobrazit objednávku',
    pending: 'Čekáme na platbu proforma faktury.',
    pendingNumber: 'Čekáme na platbu proforma faktury {{number}}.',
  },

  Detail: {
    committeMembers: 'Členové výboru',
    controlAuthority: 'Kontrolní orgán',
    externalContacts: 'Ostatní kontakty',
    emptyContactList: 'V této kategorii nejsou žádní členové.',
    isLoading: 'Probíhá načítání kontaktů…',
    updateContacts: 'Upravit kontakty',
  },

  Admins: {
    title: 'Administrátoři domu',
    invite: 'Přizvat administrátora',
    registered: 'Registrovaný administrátor',
    notRegistered: 'Pozvaný — zatím bez přístupu',
    you: 'To jste vy',
    remove: 'Odebrat roli',
    InviteModal: {
      title: 'Přizvat administrátora',
      subtitle:
        'Nový administrátor získá plný přístup ke správě domu — hlasováním, evidenci jednotek i dokumentům. Na zadaný e-mail mu pošleme pozvánku.',
      submit: 'Odeslat pozvánku',
      error: 'Administrátora se nepodařilo přizvat, zkuste to prosím znovu.',
      errorOwnerEmail:
        'Tento uživatel je v aplikaci už registrován jako vlastník jednotky — pozvánku administrátora mu proto nelze odeslat. Použijte prosím jinou e-mailovou adresu.',
      errorAlreadyAdmin: 'Tato osoba už je administrátorem tohoto domu.',
      infoExistingAdmin:
        'Existující uživatel aplikace — roli administrátora pro tento dům získá ihned po odeslání. Pozvánka se mu posílat nebude.',
      Fields: {
        FirstName: { label: 'Jméno', required: 'Jméno musí být vyplněné' },
        LastName: { label: 'Příjmení', required: 'Příjmení musí být vyplněné' },
        Email: { label: 'E-mail (pošleme na něj pozvánku)' },
        Phone: { label: 'Telefon' },
      },
      Flash: {
        success: 'Administrátor byl přizván.',
      },
    },
    RemoveModal: {
      title: 'Odebrat roli administrátora?',
      subtitle:
        '{{name}} ztratí přístup ke správě tohoto domu. O odebrání role dostane e-mail. Roli mu můžete kdykoli znovu udělit.',
      confirm: 'Odebrat roli',
      Flash: {
        success: 'Role administrátora byla odebrána.',
        error: 'Roli se nepodařilo odebrat, zkuste to prosím znovu.',
      },
    },
  },

  ContactDetail: {
    title: 'Kontakty budovy',
    Header: {
      primaryAction: 'Vytvořit nový kontakt',
    },
    Modal: {
      Form: {
        Flash: {
          successAdd: 'Kontakt byl úspěšně vytvořen.',
          successEdit: 'Kontakt byl úspěšně upraven.',
          successDelete: 'Kontakt byl úspěšně smazán.',
          errorAdd: 'Kontakt se nepodařilo vytvořit.',
          errorEdit: 'Kontakt se nepodařilo upravit.',
        },
        Fields: {
          FirstName: {
            label: 'Jméno',
            placeholder: 'Zadejte jméno kontaktu',
            required: 'Jméno musí být vyplněné',
          },
          LastName: {
            label: 'Příjmení',
            placeholder: 'Zadejte příjmení kontaktu',
            required: 'Příjmení musí být vyplněné',
          },
          Company: {
            label: 'Společnost',
            placeholder: 'Zadejte název společnosti kontaktu',
            required: 'Název společnosti musí být vyplněn',
          },
          CompanyId: {
            label: 'IČO společnosti',
            placeholder: 'Zadejte IČO společnosti kontaktu',
            required: 'IČO společnosti musí být vyplněné',
          },
          Email: {
            label: 'Email',
            placeholder: 'Zadejte email kontaktu',
          },
          Phone: {
            label: 'Telefon',
            placeholder: 'Zadejte telefonní číslo kontaktu, např. +420 xxx xxx xxx',
            required: 'Telefon je povinný',
          },
          CommitteUserType: {
            label: 'Vyberte funkci',
            chairman: 'Předseda výboru',
            deputyChairman: 'Místopředseda výboru',
            member: 'Člen výboru',
          },
          Submit: {
            title: 'Uložit změny',
            titleCreate: 'Vytvořit',
          },
        },
      },
      Delete: {
        title: 'Opravdu chcete smazat kontakt',
        confirm: 'Ano, smazat',
      },
    },
  },

  Status: {
    FetchingFailed: {
      heading: 'Registraci budovy se nepodařilo dokončit',
      subheading:
        'Bohužel se nepodařilo dokončit registraci vaší budovy — nastal problém, o kterém už ví naše technická podpora. Vyřešíme jej do 24 hodin a poté se vám ozveme. Děkujeme za pochopení.',
      buttonTitle: 'Kontaktovat podporu',
    },
    Loading: {
      string1: 'Právě pro vás připravujeme vaší budovu',
      string2: 'Shromažďujeme veškerá potřebná data',
      string3: 'Stahujeme data z katastru nemovitostí',
      string4: 'Dokončujeme stahování',
    },
  },
};
